<template>
  <div class="theme-list-content">
    <el-card @click.native="jumpDetail(info)">
      <el-row>
        <el-col class="col-wraper content-center" :span="2">
          <div class="status-img">
            <img style="width:100%" src="../../../assets/images/expire-img.png">
            <!-- <img v-if="currentTime > info.endDate" style="width:100%" src="../../../assets/images/expire-img.png">
            <img v-else-if="info.publishStatus === 0" style="width:100%" src="../../../assets/images/disable-img.png">
            <img v-else style="width:100%" src="../../../assets/images/active-img.png"> -->
          </div>
        </el-col>
        <el-col class="list-name col-wraper" :span="7">
          <el-row>
            <div class="theme-name">{{ info.themeName}}</div>
          </el-row>
          <el-row>
            <div class="area-name">{{ info.orgName}}</div>
          </el-row>
        </el-col>
        <el-col class="col-wraper content-center" :span="5">
          <div class="channel-name">{{ info.channelName }}</div>
        </el-col>
        <el-col class="col-wraper content-center" :span="9">
          <div class="date-content">{{ info.startDate | parseDate }} - {{ info.endDate | parseDate }}</div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
export default {
  // 列表项
  name: 'PerfectHistoryListItem',
  props: ['info'],
  data () {
    return {
      currentTime: new Date().getTime()
    }
  },
  mounted () {
  },
  methods: {
    // 跳转至详情
    jumpDetail (info) {
      const query = {
        type: 'update',
        class: 'detail',
        defineId: info.defineId
      }
      this.$router.push({
        path: '/trade/stack-theme-config',
        query: query
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.theme-list-content {
  display: flex;
  justify-content: center;
}
.el-card {
  width: 720px;
  height: 100%;
  border-radius: 8px;
  cursor: pointer;
}
.content-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.status-img {
  width: 50px;
  height: 50px;
}
.list-name {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 0;
}
.theme-name {
  font-size: 18px;
  font-weight: 600;
}
.channel-name {
  font-size: 15px;
  font-weight: 600;
}
.area-name {
  font-size: 12px;
  color: #7f7f7f;
}
.theme-name, .area-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 5px;
}
.date-content {
  font-size: 14px;
  color: #7f7f7f;
}
.col-wraper {
  text-align: center;
  height: 60px;
}
.tool-btns {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100px;
  padding: 10px 0px;
  box-sizing: border-box;
  .base-btn {
    width: 100px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 10px;
    font-weight: 500;
    cursor: pointer;
  }
  .update-btn {
    border: 2px solid rgba(33, 133, 208, 0.8);
    color: rgba(33, 133, 208, 0.8);
  }
  .start-btn {
    border: 2px solid #5bd28f;
    color: #5bd28f;
  }
  .disable-btn {
    border: 2px solid $base-red;
    color: $base-red;
  }
}
</style>
